import { PivotWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  SchemaProvider,
  WorkflowNodeSchemaProvider,
} from '../../registry/schema-provider.registry';

@WorkflowNodeSchemaProvider('Pivot')
export class PivotNodeSchemaProvider extends SchemaProvider<PivotWorkflowNode> {}
